import {
	Layout,
	CtaForm,
	VsCompetitorHeading,
	VsCompetitorComparison,
	VsCompetitorAdvantages,
	VsCompetitorFaq,
} from '../../../components';
import { COMPETITORS } from '../../../data/competitors';

export default function VersusCompetitor({ competitor }) {
	return (
		<Layout pageName={`Versus ${competitor.name}`}>
			<div className="versus-competitor">
				<VsCompetitorHeading {...competitor} />

				<VsCompetitorComparison {...competitor} />

				<VsCompetitorAdvantages />

				<VsCompetitorFaq />

				<CtaForm />
			</div>
		</Layout>
	);
}

export async function getServerSideProps({ params }) {
	try {
		const competitor = COMPETITORS.find(({ slug }) => slug == params.slug);

		if (!competitor) {
			return {
				notFound: true,
			};
		}

		return {
			props: {
				competitor,
			},
		};
	} catch (err) {
		console.log('🚀 ~ file: [slug].js:126 ~ getServerSideProps ~ err', err);
		return {
			notFound: true,
		};
	}
}
